import { render, staticRenderFns } from "./XSDSchema.vue?vue&type=template&id=0b991bbe&"
import script from "./XSDSchema.vue?vue&type=script&lang=js&"
export * from "./XSDSchema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports